import { render } from "./Enigme8.vue?vue&type=template&id=e5bc70cc"
import script from "./Enigme8.vue?vue&type=script&lang=js"
export * from "./Enigme8.vue?vue&type=script&lang=js"

import "./Enigme8.vue?vue&type=style&index=0&id=e5bc70cc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__